<kendo-textbox-container [floatingLabel]="label" class="full-width">
  <ng-container *ngIf="control; else valueInput">
    <div class="form-field">
      <input kendoTextBox [formControl]="control" [type]="type" class="full-width" [disabled]="disabled" autocomplete="nofill" (focus)="focus.emit()" (focusout)="focusOut.emit()" />
      <a *ngIf="showEye" class="password-eye" (click)="togglePassword()"><i class="fa" [ngClass]="{'fa-eye': isPasswordShown, 'fa-eye-slash': !isPasswordShown}" aria-hidden="true"></i></a>
    </div>
    <app-control-messages [control]="control"></app-control-messages>
  </ng-container>
  <ng-template #valueInput>
    <div class="form-field">
      <input kendoTextBox [value]="value" [type]="type" class="full-width" [disabled]="disabled" autocomplete="nofill"/>
    </div>
  </ng-template>
</kendo-textbox-container>